export type * from '@/generated/graphql/customer';

export const CustomerDocument = () => import('@/generated/graphql/customer').then(module => module.CustomerDocument);